import { render, staticRenderFns } from "./provideCommunityInfoFifth.vue?vue&type=template&id=c2e67446&scoped=true&"
import script from "./provideCommunityInfoFifth.vue?vue&type=script&lang=js&"
export * from "./provideCommunityInfoFifth.vue?vue&type=script&lang=js&"
import style0 from "./provideCommunityInfoFifth.vue?vue&type=style&index=0&id=c2e67446&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e67446",
  null
  
)

export default component.exports